import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import api from '../services/api';

export const useCompanyLogo = () => {
  return useQuery({
    queryKey: ['companyLogo'],
    queryFn: async () => {
      try {
        const response = await api.get('/uploads/logo', { responseType: 'blob' });
        return new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(response.data);
        });
      } catch (err: unknown) {
        if (isAxiosError(err) && err.response?.status === 404) {
          return null; // No logo
        }
        throw err;
      }
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
